import * as R from 'ramda';
import { CaseGranulometry } from '../cases/CaseGranulometry';
import { LevelGranulometry } from '../levels/LevelGranulometry';

export const getAllLevelsInGranulometry = (cases: CaseGranulometry[]) =>
  R.chain(({ levels }: CaseGranulometry) => levels, cases) as LevelGranulometry[];
